import { IonButton, IonCard, IonCardContent,IonCardHeader, IonHeader, IonCardTitle, IonContent, IonItem, IonLabel, IonNote, IonPage,IonToolbar, IonButtons, IonIcon,IonChip,IonNavLink, useIonModal, IonTitle} from "@ionic/react"
import React, { PropsWithChildren, useEffect, useRef, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../services/redux/hook";
import { useTranslation } from "react-i18next";
import { Asset, ProductDescription, TopUpPriceObject, TopUpProvider } from "../../types/types";
import AppHeader from "../../components/AppHeader/AppHeader";
import { arrowBackOutline,} from "ionicons/icons";
import { setGiftCardsPricing } from "../../services/redux/slices/giftcards_pricing/giftcards_pricing";
import GiftCardReviewPage from "./GiftCardReviewPage";
import GiftCardInfoComponentPage from "./GiftCardInfoComponentPage";

const GiftCardProductPage: React.FC = () => {

    const { t, i18n } = useTranslation();
    const dispatch = useAppDispatch();
    const nav = document.querySelector("ion-nav");

    const quotes = useAppSelector((state) => state.quotes.quotes);
    const [prices, setPrices] = useState<TopUpPriceObject[]>([]);
    const language = useAppSelector((state) => state.language);
    const [infoDescription, setInfoDescription] = useState<ProductDescription[]>([]);
    const pageRef = useRef();

    const [presentInfoDescription,dismissInfoDescription] = useIonModal(
        <GiftCardInfoComponentPage info={infoDescription} closeAction={()=>dismissInfoDescription()} />
      );

    const usdcToUSD: number = quotes["usd-coin"].usd;
    const usdcToEUR: number = quotes["usd-coin"].eur;

    const supportedAssets: Asset[] = useAppSelector((state) => state.supportedAssets.supportedAssets);

    const supportedTopUpAsset = supportedAssets.filter((asset) => {

        return (asset.topups_enabled)
    })

    const [topupAsset, setTopUpAsset] = useState<Asset>(supportedTopUpAsset[0]);

    const selectedProvider: TopUpProvider = useAppSelector((state) => state.selectedGiftCardProvider);
    const giftCardProducts = useAppSelector((state) => state.giftCardProducts);

    const calculatePrices = async () => {

        const selectedProviderProducts: any[] = giftCardProducts[selectedProvider.provider_code];
        const pricesToAdd: TopUpPriceObject[] = [];

        for (let i = 0; i < selectedProviderProducts.length; i++) {

            const priceRatio = selectedProviderProducts[i].maximum.SendValue / selectedProviderProducts[i].minimum.SendValue;

            if (priceRatio === 1) {

                const priceObject: any = {
                    Product: selectedProviderProducts[i],
                    Price: selectedProviderProducts[i].maximum,
                    // Promotions: promotionResponse,
                    UsdcDisplayPrice:
                        selectedProviderProducts[i].maximum.SendCurrencyIso === "USD" ?
                            selectedProviderProducts[i].maximum.SendValue * usdcToUSD :
                            selectedProviderProducts[i].maximum.SendCurrencyIso === "EUR" ?
                                selectedProviderProducts[i].maximum.SendValue / usdcToEUR :
                                undefined,
                    UsdcDisplayCustomerFee:
                        selectedProviderProducts[i].maximum.SendCurrencyIso === "USD" ?
                            selectedProviderProducts[i].maximum.CustomerFee * usdcToUSD :
                            selectedProviderProducts[i].maximum.SendCurrencyIso === "EUR" ?
                                selectedProviderProducts[i].maximum.CustomerFee / usdcToEUR :
                                undefined,
                }

                pricesToAdd.push(priceObject)
            }
        }

        setPrices(pricesToAdd)
    }

    const goToGiftCardReviewPage = (priceObject: TopUpPriceObject) => {

        dispatch(setGiftCardsPricing(priceObject));
        nav?.push(() => <GiftCardReviewPage/>);

    }

    const displayInfoPage = (info: ProductDescription[]) => {

        setInfoDescription(info);
        presentInfoDescription({
            presentingElement: pageRef.current
        })
    }


    useEffect(() => {
        
        const init = async () => {
            await calculatePrices();

        }
        init()
    }, [selectedProvider])

    return (
        <IonPage ref={pageRef} >
            <IonHeader className="ion-no-border">

                <IonToolbar >
                    <IonNavLink routerDirection={'back'}>
                        <IonButtons slot='start'>
                            <IonButton color={'primary'} onClick={() => { }}>
                                <IonIcon slot='start' icon={arrowBackOutline} />
                            </IonButton>
                        </IonButtons>
                    </IonNavLink>
                    <IonTitle> {t('giftcard.products.page.HEADER') as string} </IonTitle>

                </IonToolbar>

            </IonHeader>
     
            <IonContent style={{background:"var(ion-background-color)"}}>
                
                    {

                        prices.map((item, index) => {

                            let description: ProductDescription[] = [];

                            description = item.Product.descriptions.filter((element) => {

                                return (element.language_code === language)
                            })

                            {
                                if (!description.length) {

                                    description = item.Product.descriptions.filter((element) => {

                                        return (element.language_code === 'en')
                                    })
                                }
                            }
                            return (

                                <IonCard key={index} >

                                    <IonCardHeader color='primary'>

                                        <IonCardTitle>

                                            {/** this will add an IonChip in case a info is available */}
                                            <IonItem lines='none' color='primary' hidden={!description.length}
                                                onClick={() => { displayInfoPage(description) }}>
                                                <IonChip slot="end" outline={true}  style={{ textDecorationLine: "underline" }}>
                                                    {t('giftcard.products.page.DESCRIPTION-HEADER')}
                                                </IonChip>
                                            </IonItem>

                                            <IonItem lines="none" color='primary'>

                                                <IonLabel className="ion-text-center">

                                                    <h1>
                                                        {
                                                            item.UsdcDisplayPrice ? ((item.UsdcDisplayPrice + item.UsdcDisplayCustomerFee).toFixed(2)) : undefined

                                                        }
                                                        {
                                                            (item.Price.SendCurrencyIso === "USD" || item.Price.SendCurrencyIso === "EUR") ? ` ${topupAsset.code}` : " EUR"
                                                        }
                                                    </h1>

                                                </IonLabel>

                                            </IonItem>

                                        </IonCardTitle>

                                    </IonCardHeader>

                                    <IonCardContent>

                                        <IonItem lines="none">
                                            <IonLabel>
                                                <IonNote>
                                                    {t('giftcard.products.page.AMOUNT-LABEL')}
                                                </IonNote>
                                                <h1>
                                                    {item.Product.maximum.ReceiveValueExcludingTax} {`${item.Product.maximum.ReceiveCurrencyIso}`}
                                                </h1>

                                            </IonLabel>

                                        </IonItem>
                                    </IonCardContent>

                                    <IonItem lines="none" onClick={() => goToGiftCardReviewPage(item)}>
                                        <IonButton slot="end" shape="round" fill="outline" color='primary'>{t('topups_products.page.BUTTON-SELECT')}</IonButton>
                                    </IonItem>

                                </IonCard>

                            )
                        })

                    }

            </IonContent>

        </IonPage>
    )

}

export default React.memo(GiftCardProductPage)